import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';
import { THERAPIST_SETTINGS_PATHNAME } from '../Settings/paths';

export const STRIPE_SETTINGS_PATHNAME = `${THERAPIST_SETTINGS_PATHNAME}/stripe`;

export const StripeOAuthLoadable = loadable(async () => import('./stripe-oauth.view'), {
  fallback: <FullPageLoading />,
});
